// ============================================================================
// SWYM WISHLIST — CUSTOM JAVASCRIPT LOGIC (ULTRACOAT)
// Handles real-time counter synchronization, UI text translation, 
// DOM text patching, and automatic hash cleaner to prevent auto-open on load.
// ============================================================================

(function () {
  'use strict';

  function pageLangIsPL() {
    var lang = '';
    try {
      lang = (document.documentElement && document.documentElement.lang) || '';
    } catch (e) {}
    if (!lang && typeof navigator !== 'undefined' && navigator.language) lang = navigator.language;
    lang = String(lang || '').toLowerCase();
    return lang.indexOf('pl') === 0;
  }

  var IS_PL = pageLangIsPL();

  // ─── PART 1: HEADER COUNTER SYNCHRONIZATION ──────────────────────────────

  function setSwymCounter(count) {
    document.querySelectorAll('.swym-wishlist-header-counter').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function refreshSwymCounter() {
    setSwymCounter(readWishlistCache().length || Object.keys(pendingDrawerItems).length);
  }

  var swymAddToCartPending = false;
  var cartPollToken = 0;
  var pendingDrawerItems = {};
  var hydrateInFlight = false;
  var drawerSyncing = false;
  var WISHLIST_CACHE_KEY = 'uc-swym-wishlist';

  function cartJsonUrl() {
    var cartUrl = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
    return cartUrl.replace(/\/$/, '') + '.js';
  }

  function applyCartCount(count) {
    document.querySelectorAll('cart-count').forEach(function (el) {
      el.innerText = count;
      if (count === 0) {
        el.setAttribute('hidden', '');
        el.hidden = true;
      } else {
        el.removeAttribute('hidden');
        el.hidden = false;
      }
    });
  }

  function currentDisplayedCartCount() {
    var el = document.querySelector('cart-count');
    return el ? (parseInt(el.innerText, 10) || 0) : 0;
  }

  function refreshThemeCart(options) {
    options = options || {};
    var themeRef = window.theme || {};

    var fetchOpts = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (themeRef.utils && typeof themeRef.utils.fetchConfig === 'function') {
      fetchOpts = Object.assign({ credentials: 'same-origin' }, themeRef.utils.fetchConfig('json', 'GET'));
    }

    return fetch(cartJsonUrl(), fetchOpts)
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        applyCartCount(cart.item_count);

        if (themeRef.pubsub && themeRef.pubsub.publish && themeRef.pubsub.PUB_SUB_EVENTS) {
          themeRef.pubsub.publish(themeRef.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            source: 'swym-wishlist',
            cart: cart
          });
        }

        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cart }
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { open: options.open === true }
        }));
        return cart;
      })
      .catch(function (err) {
        console.warn('Swym cart refresh failed:', err);
        return null;
      });
  }

  function pollThemeCartUntilChanged(previousCount) {
    cartPollToken += 1;
    var token = cartPollToken;
    var attempts = 0;
    var maxAttempts = 8;

    function tick() {
      if (token !== cartPollToken) return;
      attempts += 1;
      refreshThemeCart({ open: false }).then(function (cart) {
        if (token !== cartPollToken) return;
        if (cart && cart.item_count !== previousCount) return;
        if (attempts < maxAttempts) setTimeout(tick, 280);
      });
    }

    setTimeout(tick, 180);
  }

  function isSwymAddToCartTarget(target) {
    if (!target || typeof target.closest !== 'function') return false;
    if (
      target.closest('.swym-add-to-cart-btn') ||
      target.closest('.swym-add-to-cart') ||
      target.closest('.swym-storefront-layout-grid-item-add-to-cart-button')
    ) {
      return true;
    }
    var swymRoot = target.closest('[class*="swym"], [id*="swym"]');
    return !!(swymRoot && target.closest('[class*="add-to-cart"]'));
  }

  function onSwymAddedToCart(swat) {
    refreshSwymCounter(swat);
    pollThemeCartUntilChanged(currentDisplayedCartCount());
  }

  function bindSwymCartEvents(swat) {
    var handler = function () { onSwymAddedToCart(swat); };

    try {
      if (swat.evtLayer && swat.JSEvents) {
        [swat.JSEvents.addToCart, swat.JSEvents.addedToCart].filter(Boolean).forEach(function (evt) {
          swat.evtLayer.addEventListener(evt, handler);
        });
      }
    } catch (e) {}

    try {
      if (typeof swat.addEventHandler === 'function') {
        swat.addEventHandler('addToCart', handler);
        swat.addEventHandler('addedToCart', handler);
      }
    } catch (e) {}
  }

  function swymOnLoaded(swat) {
    patchSwymProductPrefetch(swat);
    loadCacheIntoPending();
    refreshSwymCounter();
    bindSwymCartEvents(swat);

    try {
      if (typeof swat.addEventHandler === 'function') {
        swat.addEventHandler('addToList', function () {
          refreshSwymCounter();
        });
        swat.addEventHandler('removeFromList', function () {
          refreshSwymCounter();
        });
      }
    } catch (e) {}

    try {
      if (swat.evtLayer && swat.JSEvents) {
        [swat.JSEvents.addToList, swat.JSEvents.addedToWishlist, swat.JSEvents.removeFromList, swat.JSEvents.removedFromWishlist]
          .filter(Boolean)
          .forEach(function (evt) {
            swat.evtLayer.addEventListener(evt, function () {
              refreshSwymCounter();
            });
          });
      }
    } catch (e) {}
    
    document.addEventListener('click', function (e) {
      if (isSwymAddToCartTarget(e.target)) {
        swymAddToCartPending = true;
        pollThemeCartUntilChanged(currentDisplayedCartCount());
        setTimeout(function () { swymAddToCartPending = false; }, 4000);
      }
    });

    // Twarde polskie UI — tylko jeśli strona ma język pl
    if (IS_PL) {
      try {
        if (swat.ui && swat.ui.setUIConfig) {
          swat.ui.setUIConfig({
            wishlistTitle: 'Ulubione',
            headerTitle: 'Ulubione',
            addedToWishlistTitle: 'Dodano do ulubionych',
            removedFromWishlistTitle: 'Usunięto z ulubionych',
            emptyWishlistTitle: 'Twój schowek jest pusty',
            emptyWishlistMsg: 'Nie dodałeś jeszcze żadnych produktów do ulubionych.',
            loginTitle: 'Zaloguj się',
            loginMsg: 'Zaloguj się, aby zsynchronizować listę ulubionych produktów.',
            addToCartBtnText: 'Dodaj do koszyka',
            checkoutBtnText: 'Przejdź do koszyka',
            showWishlistBtnText: 'Zobacz ulubione'
          });
        }
      } catch (e) {}
    }
  }

  // Zarejestruj callback Swym
  if (window._swat) {
    swymOnLoaded(window._swat);
  } else {
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(swymOnLoaded);
  }

  function refreshSwymWishlistUI(swat) {
    var itemsContainer = document.getElementById('swym-storefront-layout-items-container');
    var hasItems = !!(itemsContainer && itemsContainer.querySelector('swym-storefront-layout-item, .swym-storefront-layout-grid-item, .swym-storefront-layout-item-fallback'));
    document.querySelectorAll('.swym-storefront-layout-empty-container, .swym-storefront-layout-empty-sfy').forEach(function (el) {
      if (hasItems) {
        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('hidden', '');
      }
    });
    document.querySelectorAll('swym-storefront-layout-default-wishlist, .swym-storefront-layout-default-list-container, #swym-storefront-layout-items-container').forEach(function (el) {
      el.removeAttribute('hidden');
      el.style.setProperty('display', 'block', 'important');
      el.style.setProperty('visibility', 'visible', 'important');
      el.style.setProperty('opacity', '1', 'important');
    });
  }
  window.refreshSwymWishlistUI = refreshSwymWishlistUI;

  // Otwórz szufladę wishlisty po kliknięciu ikonki
  document.addEventListener('click', function (e) {
    if (e.target.closest('.swym-wishlist')) {
      e.preventDefault();
      loadCacheIntoPending();
      if (window._swat && window._swat.ui && window._swat.ui.open) {
        window._swat.ui.open();
      }
      setTimeout(function () { hydrateWishlistDrawer(); }, 80);
      setTimeout(function () { hydrateWishlistDrawer(); }, 400);
    }
  });

  // ─── PART 4: CART NETWORK FALLBACK ───────────────────────────────────────
  // Swym dodaje produkt przez Shopify Ajax (/cart/add), ale motyw nie dostaje
  // swojego cartUpdate — odświeżamy UI koszyka po udanym requeście z wishlisty.
  (function patchCartAddNetwork() {
    if (window.__swymCartNetworkPatched) return;
    window.__swymCartNetworkPatched = true;

    function isCartAddUrl(url) {
      return typeof url === 'string' && /\/cart\/add/.test(url);
    }

    function afterCartAdd() {
      if (!swymAddToCartPending) return;
      pollThemeCartUntilChanged(currentDisplayedCartCount());
    }

    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function () {
        var request = arguments[0];
        var url = typeof request === 'string' ? request : (request && request.url) || '';
        return origFetch.apply(this, arguments).then(function (response) {
          if (isCartAddUrl(url) && response && response.ok) afterCartAdd();
          return response;
        });
      };
    }

    if (window.XMLHttpRequest && XMLHttpRequest.prototype) {
      var origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__swymCartAdd = isCartAddUrl(String(url || ''));
        return origOpen.apply(this, arguments);
      };
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        if (this.__swymCartAdd) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300) afterCartAdd();
          });
        }
        return origSend.apply(this, arguments);
      };
    }
  })();


  // ─── PART 2: TEXT PATCHER & MUTATION OBSERVER ────────────────────────────

  // Podmień tytuły szuflady
  function patchTitles() {
    if (!IS_PL) return;
    var titleEl = document.getElementById('swym-wishlist-title');
    if (titleEl && titleEl.textContent.trim() !== 'Ulubione') {
      titleEl.textContent = 'Ulubione';
    }
    var sflTitle = document.getElementById('swym-sfl-title');
    if (sflTitle && /wishlist|lista/i.test(sflTitle.textContent)) {
      sflTitle.textContent = 'Zapisane na później';
    }
  }

  // Podmień angielskie etykiety dostępności generowane przez Swym
  function patchAriaLabels() {
    if (!IS_PL) return;
    var labels = {
      'Wishlist': 'Ulubione',
      'Wishlist Content Section': 'Zawartość listy ulubionych',
      'Your Wishlist Collections': 'Twoje listy ulubionych'
    };
    document.querySelectorAll('[aria-label]').forEach(function(el) {
      var current = el.getAttribute('aria-label');
      if (labels[current]) el.setAttribute('aria-label', labels[current]);
    });
  }

  // Podmień teksty w tooltipie edukacyjnym
  function patchTooltip() {
    if (!IS_PL) return;
    var msg = document.querySelector('.swym-education-tooltip-message');
    if (msg) {
      var txt = msg.textContent || '';
      if (/Stuknij|Zapisuj rzeczy|wishlist/i.test(txt)) {
        msg.textContent = 'Kliknij na ikonę serduszka przy produkcie, aby dodać go do listy Ulubionych. Zaloguj się, aby zapamiętać listę na każdym urządzeniu.';
      }
    }
  }

  // Podmień teksty w action popup (dla niezalogowanych)
  function patchActionPopup() {
    if (!IS_PL) return;
    var titles = document.querySelectorAll('.swym-storefront-layout-action-title-container');
    titles.forEach(function(el) {
      var t = el.textContent.trim();
      if (/Zapisuj rzeczy|Stuknij|wishlist/i.test(t)) {
        el.textContent = 'Dodaj do listy ulubionych produkty.';
      }
    });
  }

  // Uruchom wszystkie patches
  function runAllPatches() {
    patchTitles();
    patchAriaLabels();
    patchTooltip();
    patchActionPopup();
  }

  // MutationObserver — reaguj na zmiany DOM (Swym renderuje asynchronicznie)
  var observer = new MutationObserver(function(mutations) {
    var shouldPatch = mutations.some(function(m) {
      return m.addedNodes.length > 0;
    });
    if (shouldPatch) runAllPatches();
  });

  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });

  // Uruchom po DOMContentLoaded i z opóźnieniem
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      runAllPatches();
      setTimeout(runAllPatches, 500);
      setTimeout(runAllPatches, 2000);
    });
  } else {
    runAllPatches();
    setTimeout(runAllPatches, 500);
    setTimeout(runAllPatches, 2000);
  }


  // ─── PART 3: URL HASH CLEANER ────────────────────────────────────────────

  // Jeśli URL zawiera hash Swym, wyczyść go natychmiast bez przeładowania, aby odświeżenie nie otwierało szuflady automatycznie
  if (window.location.hash === '#swym-wishlist' || window.location.hash.includes('swym')) {
    try {
      history.replaceState("", document.title, window.location.pathname + window.location.search);
    } catch (e) {}
  }

  // ─── PART 5: PDP HEART ICON FALLBACK ─────────────────────────────────────
  // Swym often leaves #swym-atw-pdp-button in atw-button-loading with an empty <svg>.
  var HEART_OUTLINE = '<path d="M12.1 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12.1 21.35zM7.5 5C5.51 5 4 6.51 4 8.5c0 2.89 2.91 5.63 7.6 9.87L12 18.7l.4-.37C17.09 14.13 20 11.39 20 8.5 20 6.51 18.49 5 16.5 5c-1.54 0-3.04.99-3.57 2.36h-1.87C10.54 5.99 9.04 5 7.5 5z" fill="currentColor"/>';
  var HEART_FILLED = '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="currentColor"/>';

  function ensureSwymHeartIcon() {
    var btn = document.getElementById('swym-atw-pdp-button');
    if (!btn) return false;
    btn.classList.remove('atw-button-loading');
    btn.style.pointerEvents = 'auto';
    btn.style.cursor = 'pointer';
    var initiallyWishlisted = btn.classList.contains('swym-added');
    var initialWishlistLabel = IS_PL
      ? (initiallyWishlisted ? 'Usuń z ulubionych' : 'Dodaj do ulubionych')
      : (initiallyWishlisted ? 'Remove from Wishlist' : 'Add to Wishlist');
    btn.setAttribute('aria-label', initialWishlistLabel);
    btn.setAttribute('title', initialWishlistLabel);
    var svg = btn.querySelector('svg');
    if (!svg) return false;
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '24');
    svg.setAttribute('height', '24');
    if (!svg.querySelector('path')) {
      svg.innerHTML = btn.classList.contains('swym-added') ? HEART_FILLED : HEART_OUTLINE;
    }
    return true;
  }

  function storefrontProductUrl() {
    return window.location.origin + (window.location.pathname || '').split('?')[0];
  }

  function productHandleFromUrl(url) {
    var match = String(url || '').match(/\/products\/([^\/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function toStorefrontProductUrl(url) {
    var handle = productHandleFromUrl(url);
    if (handle) return window.location.origin + '/products/' + handle;
    return url || storefrontProductUrl();
  }

  function rewritePrefetchValue(value, depth) {
    if ((depth || 0) > 6 || value == null) return value;
    if (typeof value === 'string') {
      if (/\/products\//i.test(value)) return toStorefrontProductUrl(value);
      return value;
    }
    if (Array.isArray(value)) {
      return value.map(function (item) { return rewritePrefetchValue(item, (depth || 0) + 1); });
    }
    if (typeof value === 'object' && value.constructor === Object) {
      var next = {};
      Object.keys(value).forEach(function (key) {
        next[key] = rewritePrefetchValue(value[key], (depth || 0) + 1);
      });
      return next;
    }
    return value;
  }

  function patchSwymProductPrefetch(swat) {
    if (!swat || !swat.h || swat.h.__ucPrefetchPatched) return;
    swat.h.__ucPrefetchPatched = true;

    ['fetchProductForItemsJSON', 'fetchProductForItems'].forEach(function (name) {
      var original = swat.h[name];
      if (typeof original !== 'function') return;
      swat.h[name] = function () {
        var args = Array.prototype.slice.call(arguments).map(function (arg) {
          return rewritePrefetchValue(arg);
        });
        return original.apply(this, args);
      };
    });
  }

  function resolveSwymProductParams() {
    var btn = document.getElementById('swym-atw-pdp-button');
    var productId = parseInt((btn && (btn.getAttribute('data-product-id') || btn.dataset.productId)) || 0, 10);
    var variantId = parseInt((btn && (btn.getAttribute('data-variant-id') || btn.dataset.variantId || btn.dataset.variantid)) || 0, 10);
    var productUrl = storefrontProductUrl();

    if (!variantId) {
      var variantInput = document.querySelector('.product-form input[name="id"], product-form input[name="id"], input[name="id"]');
      variantId = parseInt((variantInput && variantInput.value) || 0, 10);
    }
    if (!productId) {
      var productInfo = document.querySelector('.product__info[data-product-id], [data-product-id]');
      productId = parseInt((productInfo && productInfo.getAttribute('data-product-id')) || 0, 10);
    }

    if (btn) {
      if (productId) btn.setAttribute('data-product-id', productId);
      if (variantId) btn.setAttribute('data-variant-id', variantId);
      btn.setAttribute('data-du', productUrl);
    }

    return { empi: productId, epi: variantId, du: productUrl };
  }

  function buildSwymProduct(done) {
    var base = resolveSwymProductParams();
    fetch(window.location.pathname.split('?')[0] + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var variant = (p.variants || []).filter(function (v) { return v.id == base.epi; })[0] || (p.variants || [])[0] || {};
        if (!base.empi) base.empi = p.id;
        if (!base.epi) base.epi = variant.id;
        base.dt = p.title;
        base.pr = variant.price != null ? variant.price : p.price;
        var img = (variant.featured_image && (variant.featured_image.src || variant.featured_image)) || p.featured_image || (p.images && p.images[0]);
        if (img) base.iu = String(img).indexOf('//') === 0 ? ('https:' + img) : img;
        done(base);
      })
      .catch(function () { done(base); });
  }

  function readWishlistCache() {
    try {
      var raw = window.localStorage.getItem(WISHLIST_CACHE_KEY);
      var items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlistCache(items) {
    try {
      window.localStorage.setItem(WISHLIST_CACHE_KEY, JSON.stringify(items || []));
    } catch (e) {}
  }

  function saveItemToCache(params) {
    if (!params || !params.epi) return;
    var items = readWishlistCache().filter(function (item) {
      return String(item.epi) !== String(params.epi);
    });
    items.unshift({
      empi: params.empi,
      epi: params.epi,
      du: params.du,
      dt: params.dt,
      pr: params.pr,
      iu: params.iu
    });
    writeWishlistCache(items);
  }

  function removeItemFromCache(params) {
    if (!params || !params.epi) return;
    writeWishlistCache(readWishlistCache().filter(function (item) {
      return String(item.epi) !== String(params.epi);
    }));
  }

  function loadCacheIntoPending() {
    readWishlistCache().forEach(function (item) {
      var params = swymItemToParams(item);
      if (params && params.epi) pendingDrawerItems[String(params.epi)] = params;
    });
    var count = Object.keys(pendingDrawerItems).length || readWishlistCache().length;
    if (count) setSwymCounter(count);
    restoreHeartFromCache();
  }

  function restoreHeartFromCache() {
    var btn = document.getElementById('swym-atw-pdp-button');
    if (!btn) return;
    var epi = btn.getAttribute('data-variant-id') || btn.dataset.variantId;
    var empi = btn.getAttribute('data-product-id') || btn.dataset.productId;
    var cached = readWishlistCache().some(function (item) {
      return (epi && String(item.epi) === String(epi)) || (empi && String(item.empi) === String(empi));
    });
    if (cached) paintSwymHeart(true);
  }

  function flattenSwymListResponse(data) {
    if (!data) return [];
    if (Array.isArray(data)) {
      if (!data.length) return [];
      if (data[0] && (data[0].epi || data[0].empi || data[0].dt || data[0].listcontents || data[0].listContents)) {
        if (data[0].epi || data[0].empi || data[0].dt) return data;
        return data.reduce(function (acc, list) {
          return acc.concat(list.listcontents || list.listContents || list.items || []);
        }, []);
      }
      return data;
    }
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.listcontents)) return data.listcontents;
    if (Array.isArray(data.listContents)) return data.listContents;
    if (Array.isArray(data.lists)) return flattenSwymListResponse(data.lists);
    if (data.data) return flattenSwymListResponse(data.data);
    return [];
  }

  function fetchSwymListItems(swat, done) {
    if (!swat || typeof swat.flushWishList !== 'function') {
      done(readWishlistCache());
      return;
    }
    var settled = false;
    var timer = setTimeout(function () {
      if (settled) return;
      settled = true;
      done(readWishlistCache());
    }, 800);
    try {
      swat.flushWishList(function (result) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        var items = flattenSwymListResponse(result);
        done(items.length ? items : readWishlistCache());
      });
    } catch (e) {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      done(readWishlistCache());
    }
  }

  function formatSwymMoney(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat || theme.settings.moneyWithCurrencyFormat);
    }
    return (Number(cents) / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  var TRASH_ICON = '<svg viewBox="0 0 16 16" width="16" height="16" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M2.66683 3.33337L3.15631 11.6546C3.21868 12.7148 3.24986 13.2449 3.47613 13.6472C3.67533 14.0013 3.97765 14.2864 4.34288 14.4644C4.75775 14.6667 5.28877 14.6667 6.35079 14.6667H9.64953C10.7116 14.6667 11.2426 14.6667 11.6575 14.4644C12.0227 14.2864 12.325 14.0013 12.5242 13.6472C12.7505 13.2449 12.7816 12.7148 12.844 11.6546L13.3335 3.33337M2.66683 3.33337H1.3335M2.66683 3.33337H13.3335M13.3335 3.33337H14.6668M10.6668 3.33337L10.6326 3.23074C10.4636 2.72375 10.3791 2.47025 10.2492 2.26473C9.97328 1.82822 9.53921 1.51536 9.03785 1.39163C8.80179 1.33337 8.53458 1.33337 8.00016 1.33337V1.33337C7.46575 1.33337 7.19854 1.33337 6.96248 1.39163C6.46112 1.51536 6.02705 1.82822 5.75112 2.26473C5.6212 2.47025 5.5367 2.72375 5.36771 3.23074L5.3335 3.33337M6.66683 6.66671V11.3334M9.3335 6.66671V9.33337"></path></svg>';

  function fallbackItemInnerHtml(params) {
    var addToCartText = IS_PL ? 'Dodaj do koszyka' : 'ADD TO CART';
    var removeAria = IS_PL ? 'Usuń z ulubionych' : 'Remove from wishlist';
    var href = params.du || storefrontProductUrl();
    var img = params.iu || '';
    var title = String(params.dt || '');
    var price = formatSwymMoney(params.pr || 0);
    var safeTitle = title.replace(/"/g, '&quot;');
    return (
      '<div class="swym-storefront-layout-grid-item">' +
        '<a href="' + href + '" class="swym-storefront-layout-grid-item-image-container">' +
          (img ? '<img src="' + img + '" alt="' + safeTitle + '" class="swym-storefront-layout-grid-item-image">' : '') +
        '</a>' +
        '<div class="swym-storefront-layout-grid-item-content">' +
          '<div class="swym-storefront-layout-grid-item-price-variant">' +
            '<span class="swym-storefront-layout-grid-item-final-price">' + price + '</span>' +
          '</div>' +
          '<a href="' + href + '" class="swym-storefront-layout-grid-item-title">' + title + '</a>' +
          '<div class="swym-storefront-layout-grid-item-action-container">' +
            '<button type="button" class="swym-storefront-layout-grid-item-add-to-cart-button swym-fallback-add-to-cart">' + addToCartText + '</button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="swym-storefront-layout-grid-item-option-button swym-storefront-layout-delete-btn swym-fallback-delete" aria-label="' + removeAria + '">' +
          TRASH_ICON +
        '</button>' +
      '</div>'
    );
  }

  function cartAddUrl() {
    var addUrl = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
    return /\.js(\?|$)/.test(addUrl) ? addUrl : addUrl.replace(/\/$/, '') + '.js';
  }

  function addFallbackItemToCart(wrap, button) {
    var addingText = IS_PL ? 'Dodawanie...' : 'Adding...';
    var addedText = IS_PL ? 'Dodano do koszyka' : 'Added to cart';
    var addToCartText = IS_PL ? 'Dodaj do koszyka' : 'Add to cart';
    var epi = parseInt(wrap.getAttribute('data-epi'), 10);
    if (!epi || !button || button.getAttribute('aria-busy') === 'true') return;
    var original = button.textContent;
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = addingText;
    swymAddToCartPending = true;
    fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: epi, quantity: 1 })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function () {
        button.textContent = addedText;
        refreshThemeCart({ open: false });
        pollThemeCartUntilChanged(currentDisplayedCartCount());
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = original || addToCartText;
      })
      .then(function () {
        button.removeAttribute('aria-busy');
        setTimeout(function () { swymAddToCartPending = false; }, 4000);
      });
  }

  function upsertWishlistDrawerItem(params, options) {
    if (!params || !params.epi) return;
    options = options || {};
    params = Object.assign({}, params, { du: toStorefrontProductUrl(params.du) });
    pendingDrawerItems[String(params.epi)] = params;
    saveItemToCache(params);

    var container = document.getElementById('swym-storefront-layout-items-container');
    if (!container) return;

    var existing = container.querySelector('.swym-storefront-layout-item-fallback[data-epi="' + params.epi + '"]');
    if (existing) {
      // Always refresh fallback contents so language-specific labels stay correct
      existing.setAttribute('data-du', params.du || storefrontProductUrl());
      existing.innerHTML = fallbackItemInnerHtml(params);
      return;
    }

    var wrap = document.createElement('div');
    wrap.id = 'swym-storefront-layout-item-' + params.empi + '-' + params.epi;
    wrap.className = 'swym-storefront-layout-item-fallback';
    wrap.setAttribute('data-epi', params.epi);
    wrap.setAttribute('data-empi', params.empi);
    wrap.setAttribute('data-du', params.du || storefrontProductUrl());
    wrap.innerHTML = fallbackItemInnerHtml(params);

    if (options.append) container.appendChild(wrap);
    else container.insertBefore(wrap, container.firstChild);
  }

  function removeWishlistDrawerItem(params) {
    if (!params || !params.epi) return;
    delete pendingDrawerItems[String(params.epi)];
    removeItemFromCache(params);
    drawerSyncing = true;
    document.querySelectorAll(
      '.swym-storefront-layout-item-fallback[data-epi="' + params.epi + '"], swym-storefront-layout-item[data-epi="' + params.epi + '"]'
    ).forEach(function (el) {
      el.remove();
    });
    refreshSwymWishlistUI();
    refreshSwymCounter();
    requestAnimationFrame(function () { drawerSyncing = false; });
  }

  function swymItemToParams(item) {
    if (!item) return null;
    return {
      empi: item.empi || item.empi_id || item.productId,
      epi: item.epi || item.epi_id || item.variantId,
      du: toStorefrontProductUrl(item.du || item.uri || item.url),
      dt: item.dt || item.title,
      pr: item.pr || item.price,
      iu: item.iu || item.image || item.imageurl
    };
  }

  function fillParamsFromProductJson(params, done) {
    if (!params) return done(params);
    if (params.dt && params.iu) return done(params);
    var handle = productHandleFromUrl(params.du);
    if (!handle) return done(params);
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (p) {
        var variant = (p.variants || []).filter(function (v) { return v.id == params.epi; })[0] || (p.variants || [])[0] || {};
        if (!params.empi) params.empi = p.id;
        if (!params.epi) params.epi = variant.id;
        if (!params.dt) params.dt = p.title;
        if (params.pr == null) params.pr = variant.price != null ? variant.price : p.price;
        var img = (variant.featured_image && (variant.featured_image.src || variant.featured_image)) || p.featured_image || (p.images && p.images[0]);
        if (img && !params.iu) params.iu = String(img).indexOf('//') === 0 ? ('https:' + img) : img;
        done(params);
      })
      .catch(function () { done(params); });
  }

  function drawerItemCount() {
    var container = document.getElementById('swym-storefront-layout-items-container');
    if (!container) return 0;
    return container.querySelectorAll('.swym-storefront-layout-item-fallback').length;
  }

  function restoreDrawerFromCache() {
    if (drawerSyncing) return;
    drawerSyncing = true;
    var cache = readWishlistCache();
    cache.forEach(function (item) {
      upsertWishlistDrawerItem(swymItemToParams(item), { append: true });
    });
    var allowed = {};
    cache.forEach(function (item) {
      if (item && item.epi) allowed[String(item.epi)] = true;
    });
    document.querySelectorAll('.swym-storefront-layout-item-fallback').forEach(function (el) {
      if (!allowed[el.getAttribute('data-epi')]) el.remove();
    });
    refreshSwymWishlistUI();
    refreshSwymCounter();
    drawerSyncing = false;
  }

  function observeDrawerContainer() {
    var container = document.getElementById('swym-storefront-layout-items-container');
    if (!container || container.__ucRestoreObserved) return;
    container.__ucRestoreObserved = true;
    var observer = new MutationObserver(function () {
      if (drawerSyncing) return;
      if (drawerItemCount() < readWishlistCache().length) restoreDrawerFromCache();
    });
    observer.observe(container, { childList: true });
  }

  function paramsFromDrawerItem(el) {
    if (!el) return null;
    var root = el.closest('[data-epi]') || el.closest('swym-storefront-layout-item') || el.closest('.swym-storefront-layout-grid-item');
    if (!root) return null;
    var epi = parseInt(root.getAttribute('data-epi'), 10);
    var empi = parseInt(root.getAttribute('data-empi'), 10);
    var titleEl = root.querySelector('.swym-storefront-layout-grid-item-title');
    var title = titleEl ? titleEl.textContent.trim() : '';
    if (!epi && title) {
      var cached = readWishlistCache().filter(function (item) {
        return String(item.dt || '').trim() === title;
      })[0];
      if (cached) return swymItemToParams(cached);
    }
    if (!epi) return null;
    return { epi: epi, empi: empi || 0 };
  }

  function hydrateWishlistDrawer() {
    observeDrawerContainer();
    loadCacheIntoPending();
    restoreDrawerFromCache();
  }

  function paintSwymHeart(isWishlisted) {
    var btn = document.getElementById('swym-atw-pdp-button');
    if (!btn) return;
    btn.classList.remove('atw-button-loading');
    btn.classList.toggle('swym-added', !!isWishlisted);
    var wishlistLabel = IS_PL
      ? (isWishlisted ? 'Usuń z ulubionych' : 'Dodaj do ulubionych')
      : (isWishlisted ? 'Remove from Wishlist' : 'Add to Wishlist');
    btn.setAttribute('aria-label', wishlistLabel);
    btn.setAttribute('title', wishlistLabel);
    var svg = btn.querySelector('svg');
    if (!svg) return;
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.innerHTML = isWishlisted ? HEART_FILLED : HEART_OUTLINE;
  }

  function callSwymListApi(swat, add, params, onDone) {
    var finished = false;
    function done(ok) {
      if (finished) return;
      finished = true;
      onDone(ok);
    }
    setTimeout(function () { done(false); }, 8000);

    var addFn = typeof swat.addToWishList === 'function' ? swat.addToWishList.bind(swat)
      : (typeof swat.addToWishlist === 'function' ? swat.addToWishlist.bind(swat) : null);
    var removeFn = typeof swat.removeFromWishList === 'function' ? swat.removeFromWishList.bind(swat)
      : (typeof swat.removeFromWishlist === 'function' ? swat.removeFromWishlist.bind(swat) : null);
    var fn = add ? addFn : removeFn;

    if (!fn) {
      var lid = (document.getElementById('swym-storefront-layout-items-container') || {}).getAttribute?.('data-lid');
      if (add && lid && typeof swat.addProductToList === 'function') {
        try {
          swat.addProductToList(params, lid, function () { done(true); }, function (err) {
            console.error('[Swym] addProductToList error', err);
            done(false);
          });
          return;
        } catch (e) {
          console.error('[Swym] addProductToList threw', e);
        }
      }
      console.warn('[Swym] No add/remove API method found on _swat');
      done(false);
      return;
    }

    try {
      fn(params, function (result) {
        console.log('[Swym] list API ok', add ? 'add' : 'remove', result);
        done(true);
      });
    } catch (e) {
      console.error('[Swym] list API threw', e);
      done(false);
    }
  }

  function whenSwatReady(callback) {
    var done = false;
    function fire(swat) {
      if (done) return;
      done = true;
      callback(swat);
    }

    var swat = window._swat || window.swat;
    if (swat) {
      fire(swat);
      return;
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (readySwat) {
      fire(readySwat || window._swat || window.swat);
    });

    var attempts = 0;
    var poll = setInterval(function () {
      attempts += 1;
      var ready = window._swat || window.swat;
      if (ready) {
        clearInterval(poll);
        fire(ready);
        return;
      }
      if (attempts >= 50) {
        clearInterval(poll);
        fire(null);
      }
    }, 200);
  }

  function runHeartToggle(swat, adding) {
    patchSwymProductPrefetch(swat);
    buildSwymProduct(function (params) {
      if (!params.empi || !params.epi) {
        console.warn('[Swym] Heart toggle aborted — missing ids', params);
        paintSwymHeart(!adding);
        return;
      }
      params.du = toStorefrontProductUrl(params.du);
      console.log('[Swym] Heart toggle', adding ? 'add' : 'remove', params);
      callSwymListApi(swat, adding, params, function (ok) {
        if (!ok) {
          paintSwymHeart(!adding);
          return;
        }
        if (adding) upsertWishlistDrawerItem(params);
        else removeWishlistDrawerItem(params);
        refreshSwymCounter();
      });
    });
  }

  if (!window.__swymHeartClickBound) {
    window.__swymHeartClickBound = true;
    document.addEventListener('click', function (e) {
      var del = e.target && e.target.closest && e.target.closest('.swym-fallback-delete');
      if (del) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        var wrap = del.closest('[data-epi]');
        if (!wrap) return;
        var params = {
          empi: parseInt(wrap.getAttribute('data-empi'), 10),
          epi: parseInt(wrap.getAttribute('data-epi'), 10)
        };
        if (!params.epi) return;
        paintSwymHeart(false);
        removeWishlistDrawerItem(params);
        whenSwatReady(function (swat) {
          if (swat) callSwymListApi(swat, false, params, function () {});
        });
        return;
      }

      var nativeDel = e.target && e.target.closest && e.target.closest('.swym-storefront-layout-delete-btn, #swym-storefront-layout-grid-item-option-button');
      if (nativeDel) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        var nativeParams = paramsFromDrawerItem(nativeDel);
        var nativeRoot = nativeDel.closest('.swym-storefront-layout-item-fallback')
          || nativeDel.closest('swym-storefront-layout-item')
          || nativeDel.closest('.swym-storefront-layout-grid-item');
        if (nativeParams && nativeParams.epi) {
          paintSwymHeart(false);
          removeWishlistDrawerItem(nativeParams);
          if (nativeRoot && nativeRoot.parentNode) nativeRoot.remove();
          whenSwatReady(function (swat) {
            if (swat) callSwymListApi(swat, false, nativeParams, function () {});
          });
        } else if (nativeRoot) {
          nativeRoot.remove();
        }
        return;
      }

      var addBtn = e.target && e.target.closest && e.target.closest('.swym-fallback-add-to-cart');
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        var addWrap = addBtn.closest('[data-epi]');
        if (addWrap) addFallbackItemToCart(addWrap, addBtn);
        return;
      }

      var btn = e.target && e.target.closest && e.target.closest('#swym-atw-pdp-button');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      var adding = !btn.classList.contains('swym-added');
      paintSwymHeart(adding);

      whenSwatReady(function (swat) {
        if (!swat) {
          console.warn('[Swym] Heart click queued but _swat never became ready');
          paintSwymHeart(!adding);
          return;
        }
        patchSwymProductPrefetch(swat);
        runHeartToggle(swat, adding);
      });
    }, true);
  }

  ensureSwymHeartIcon();
  loadCacheIntoPending();
  restoreHeartFromCache();
  setTimeout(ensureSwymHeartIcon, 400);
  setTimeout(restoreHeartFromCache, 400);

  if (document.body) {
    var heartTries = 0;
    var heartObserver = new MutationObserver(function () {
      heartTries += 1;
      if (ensureSwymHeartIcon() || heartTries > 20) heartObserver.disconnect();
    });
    heartObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { heartObserver.disconnect(); }, 4000);
  }

})();
